import { Component, OnInit, Input, ViewChild} from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { MatSnackBar } from '@angular/material';
import { RespostaListaDinamicaService } from 'unb-questionario-componente';
import { SituacaoEnum } from '../util/situacao.enum';
import { Inscricao } from '../inscricao/inscricao';
import { InscricaoService } from '../inscricao/inscricao.service';
import { InscricaoProfessorComponent } from '../inscricao-professor/inscricao-professor.component';
import { InscricaoTrabalhoListComponent } from '../inscricao-trabalho/inscricao-trabalho-list.component';

@Component({
  selector: 'inscricao-detail',
  templateUrl: './inscricao-detail.component.html',
  styleUrls: [ './inscricao-detail.component.css' ]
})
export class InscricaoDetailComponent implements OnInit {
    public inscricao : Inscricao;
    public isLoading: boolean;
    public ehAdmin : boolean = false;
    public mensagemTela: string;
    public quantidadeTrabalhos: number;
    @ViewChild(InscricaoProfessorComponent) inscricaoProfessorComponent: InscricaoProfessorComponent;
    @ViewChild(InscricaoTrabalhoListComponent) inscricaoTrabalhoLisComponent: InscricaoTrabalhoListComponent;

    constructor(private route: ActivatedRoute,
      private router: Router,
      private inscricaoService: InscricaoService,
      private respostaService: RespostaListaDinamicaService,
      private mensagem: MatSnackBar)  {
    }

    ngOnInit(){
      let id:any = this.route.snapshot.params['id'];
      this.ehAdmin =this.route.snapshot.params['ehAdmin'];

      if (id){
        this.isLoading= true;
        this.inscricaoService.getId(parseInt(id)).subscribe(
          result => {
            this.inscricao = result;
            this.isLoading= false;
          },
          error => this.erro(error)
        );
      }else {
        this.inicializa();
      }
    }


    private inicializa():void{
      // carrega o código da pessoa pelo local storage
      let storage = JSON.parse(localStorage.getItem("editaltese"));
      let resource_owner = storage.resource_owner;
      const codigoPessoa = resource_owner.codigo;
      this.isLoading = true;
      this.inscricaoService.inicializa(codigoPessoa).subscribe(
        result=>{
          this.inscricao = result;
          if(this.inscricao.situacao == SituacaoEnum.EmAnalise.id && !this.ehAdmin){
            this.mensagem.open("Sua inscrição foi concluída e será analisada. ", 'X', {duration: 5000});
          }
          this.isLoading = false;
        },
          error => this.erro(error)
        );
    }

    inscricaoEmitida(inscricao:Inscricao){
      this.inscricao = inscricao;
    }

    conclusaoEmitida(inscricao:Inscricao){
      this.inscricao = inscricao;
      this.inscricaoProfessorComponent.controlaBotaoSalvar();
      this.inscricaoTrabalhoLisComponent.controlaBotaoSalvar();
    }


    quantidadeTrabalhosEmitida(qtd: number){
      this.quantidadeTrabalhos = qtd;
    }

    // mostra erros na tela
   erro(erro: string){
       this.mensagem.open(erro, 'X', {duration: 5000});
       this.isLoading =false;
   }
}
